import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { DisplayMsg } from "../services/toastService";

const PAYMENT_API_BASE_URL = process.env.REACT_APP_PAYMENT_API_BASE_URL;
const PATIENT_API_BASE_URL = process.env.REACT_APP_BASE_PATIENT_URL;

const getMerchantData = async (token, apiKey, practiceId) => {
  try {
    const url = `${PATIENT_API_BASE_URL}/v1/Practice/${practiceId}/Credentials/Payrix?isPublic=true`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      APIKey: apiKey,
    };

    const response = await axios.get(url, { headers });
    return response.data?.data;
  } catch (error) {
    console.error("Error fetching merchant ID:", error);
    DisplayMsg("2", "Failed to fetch Merchant ID. Please try again.");
    return null;
  }
};

export const useMerchantData = (token, apiKey, practiceId) =>
  useQuery({
    queryKey: ["merchantData", practiceId],
    queryFn: async () => getMerchantData(token, apiKey, practiceId),
    enabled: !!practiceId && !!apiKey && !!token,
    staleTime: 0,
  });

export const updateMerchantId = async (token, apiKey, merchantId) => {
  try {
    const url = `${PAYMENT_API_BASE_URL}/v1/Payrix/Merchant/${merchantId}/ApiKey`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      APIKey: apiKey,
    };

    const response = await axios.get(url, {
      headers,
    });

    return response.data;
  } catch (error) {
    console.error("Error updating merchant ID:", error);
    DisplayMsg("2", "Failed to update Merchant ID. Please try again.");
    return null;
  }
};
